var app = angular.module("leonardo");

var ContactTypeListActions = function($scope, $state, ngDialog, AuthDataService, PermissionService) {

  $scope.authDataService = AuthDataService;
  $scope.permissionService = PermissionService;

  $scope.addType = function(){
    ngDialog.open({
      controller: 'ContactTypeEditDialog',
      templateUrl: 'views/templates/dialog/contact/contact-type.html',
      data: {
        type: undefined
      }
    });
  };
};

app.controller('ContactTypeListActions', ['$scope', '$state', 'ngDialog', 'AuthDataService', 'PermissionService', ContactTypeListActions]);
